import axios from 'axios'
// import NProgress from 'nprogress';
import router from "@/system_modules/router";
import { _G } from "./_common";


// axios.interceptors.request.use(req => {
//     // NProgress.start();
//     return req;
// }, (error) => {
//     // NProgress.done();
//     // if( error.response === undefined ){
//     //     return Promise.reject(error);
//     // }
//     return error;
// });


// // Encrypt outgoing requests
// axios.interceptors.request.use((config) => {
//     if(config && typeof config.data == FormData && config.data1 !== undefined && config.data1 != null){
//     // if(config && config.data1 !== undefined && config.data1 != null){
//         // const formData = new FormData();
//         let fd = config.data;
//         fd.append("data", _G.encryptData(config.data1));
//         config.data = fd;
//     }
//     else if(config && config.data1 !== undefined && config.data1 != null){
//         const fd = new FormData();
//         // let fd = config.data;
//         fd.append("data", _G.encryptData(config.data1));
//         config.data = fd;
//     }
//     // else if(config && config.data1 !== undefined && config.data1 != null){
//     //     config.data = _G.encryptData(config.data1);
//     // }
//     return config;
// }, (error) => {
//     // NProgress.done();
//     // if( error.response === undefined ){
//     //     return Promise.reject(error);
//     // }
//     return error;
// });

// // Decrypt incoming responses
// api.interceptors.response.use((response) => {
//     if (response.data && response.data.data) {
//         response.data = decryptData(response.data.data);
//     }
//     return response;
// });


// console.log(decryptData('fbLz8YUGi2gEmo6xKbT8CabOfxWpEKpG/coHehBnuE/kSn7gTPYufHQvD49q6aaOerJOsRE07TN53YNfhZ5Vw9xiBLHtj1XfDePkMpS627092ruQ2JZxeO/sxn2Uyt5c8ptteb9fjmwRh1/6yu+dAXCvDwUSmjht35hhx25vfN8oVNABLatroGOLqNRYJ3DiBQHPLtV60VJfVG61qYEtmHx2yN3RlVUWBq36IRMuFraTJy65C1OYWtVLOCFrEVWC8CcE/E/7QKYz5V/4IZeIkdlHKOaG5y2XJwYMLHjDuMe5BfrUFUwOJtlPJZp/ynqVmhloJ6YydMu+WIXeA5C6zR3Iv/Lz1hxlKYz/cpre2ipUIwLrHMKYYhfK3atVbORKn5r9DANPF3fL+70SkJttMAxFKqgCN2JlGdeFSpPIgpbcjd80N09rAiZ0rpUbmCwlruWzj9WikQpkEKFoDGm0gnYTfAs1rlJRCcjh5wJx54T7ABLmaaLiYmkAwSBsrDtVIJ7RizbJmxk7wL/GCkJcng=='));


axios.interceptors.response.use(
    response => {
        // NProgress.done();

        if (response === undefined) {
            _G.alert.error({toast: true, position: 'center', msg: 'Server Connection Error !'});
            return Promise.reject(response);
        }
        // else if (response !== undefined) {
        //     _G.alert.error({toast: true, position: 'center', msg: 'Server Connection Error !'});
        //     return Promise.reject(response);
        // }

        // if (response.data !== undefined && response.data.data !== undefined) {
        //     response.data = _G.decryptData(response.data.data);
        //     console.log(response.data);
        // }

        return response;

    }, (error) => {
        // NProgress.done();
        if (error.response === undefined) {
            _G.alert.error({toast: true, position: 'center', msg: 'Server Connection Error !'});
            return Promise.reject(error);
        }
        else if (error.response.status == 0 && error.code == 'ERR_NETWORK') {
            // _G.alert.error({toast: true, position: 'center', msg: `${error.message}`});
            return Promise.reject(error);
        }
        // else if (error.response.status == 422 && error.code == 'ERR_BAD_REQUEST') {
        //     _G.closeModalAll();
        //     // router.push({ name: 'login', query: { redirect: window.location.pathname }, replace: true });
        //     // _G.alert.warning({ toast: true, position: 'center', msg: _G.getErrorMessages(error.response.data.detail) });
        //     return Promise.reject(error);
        // }
        else if (error.response.status == 401) {
            _G.closeModalAll();
            router.push({ name: 'login', query: { redirect: window.location.pathname }, replace: true });
            // _G.alert.warning({ toast: true, position: 'center', msg: _G.getErrorMessages(error.response.data.detail) });
            return Promise.reject(error);
        }
        else if (error.response.status == 408) {
            // _G.setClientData("AUTH_TOKEN", '');
            _G.closeModalAll();
            router.push({ name: 'login', query: { redirect: window.location.pathname }, replace: true });
            // _G.alert.error({toast: true, position: 'center', msg: error.response.data.detail});
            // router.go();
            return Promise.reject(error);
        }
        else{
            return error;
        }
    }
);

export const ajax = async (opt = null) => {
    if (opt != null && opt.url !== undefined && opt.url != ""){
        let aHeaders = {
            // "Content-Type": opt.contentType || "multipart/form-data",
            // "Authorization": this._TOKEN,
            // "X-Requested-With": "XMLHttpRequest",
            // "X-CSRF-TOKEN": document.getElementsByName('X-CSRF-TOKEN')[0].content,
            // 'Access-Control-Allow-Origin': '*',
            // "Accept": 'application/json',
            'Content-Type': opt && opt.content_type ? opt.content_type : 'application/x-www-form-urlencoded',
            "Authorization": opt && opt.token ? `Bearer ${opt.token}` : _G.getClientData("AUTH_TOKEN"),
        };
        Object.keys(_G.ajaxHeaders).forEach((k) => {
            aHeaders[k] = (typeof _G.ajaxHeaders[k] === 'function' ) ? _G.ajaxHeaders[k]() : _G.ajaxHeaders[k];
        });

        await axios({
            // baseURI parameter defined on user side when call ajax function.
            baseURL: opt && opt.baseURI !== undefined && opt.baseURI != '' ? _G.ajaxBaseUrl[opt.baseURI] : _G.ajaxBaseUrl['default'],
            url: opt.url,
            method: opt.method || "get",
            data: opt.data || null,
            data1: opt.data1 || null,
            // crossDomain: true,
            responseType: opt.responseType ? opt.responseType : null,
            headers: opt.header || aHeaders,
            // timeout: 3000,
            // config: {
            //     headers: {
            //         // 'Content-Type': 'multipart/form-data',
            //         "Access-Control-Allow-Origin": "http://localhost:8080",
            //     }
            // },
            withCredentials: false,
            // credentials: 'same-origin',
            // crossDomain: true,
        }).then(async (response) => {
            // if (response.data && response.data.token && response.data.token != "") {
            //     this._TOKEN = response.data.token;
            // }
            if ( response.status == 200 ){
                // _G.ajaxHeaders['X-DIARC-Security'] = btoa(_G.aEncrypt(atob(_G.aDecrypt(response.headers['x-content-sec'], 3))));
                if (opt.success !== undefined && opt.success != null){
                    await opt.success(response);
                }
            }
            else if( response.status == 202 ){
                _G.alert.error({ toast: true, position: 'center', msg: response.data.detail });
            }
            // else if( response.status == 401 ){
            //     _G.alert.error({ toast: true, position: 'center', msg: "AYEEEEE !!!!" });
            // }
            else{
                if (opt.error !== undefined && opt.error != null){
                    await opt.error(response);
                }

                // else if( response.response != undefined && response.response.status != 200 ){
                else if( response.response != undefined ){
                    _G.alert.error({toast: true, position: 'center', msg: _G.getErrorMessages(response.response.data.detail)});
                }
                else{
                    _G.alert.error({toast: true, position: 'center', msg: _G.getErrorMessages(response.data.detail)});
                }
            }
        }).catch(async (error) => {
            let resp = error.response;
            if (opt.error !== undefined && opt.error != null && resp !== undefined){
                await opt.error(error);
            }
            else if (resp && resp.data){
                _G.alert.error({toast: true, position: 'center', msg: _G.getErrorMessages(resp.data.detail)});
            }
            // return Promise.reject(error);
        });
    }
};
